import { endOfDay } from 'date-fns';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useTasksQuery } from 'shared/hooks/queries/use-tasks-query';
import { useUser } from 'shared/hooks/use-user';

export const useTodaysDeadlineDeadlineTasks = () => {
  const today = useToday();
  const user = useUser();

  const { data: tasks } = useTasksQuery(user?.uid, {
    deadlineDeadlineEndDate: endOfDay(today),
    unFrozenOnly: true,
    uncompletedOnly: true,
  });

  return useMemo(
    () => tasks?.filter(({ archivedAt }) => !archivedAt) ?? [],
    [tasks],
  );
};
